
export default {
  name: 'VsTab',
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  vessel: {
    tab: {
      paddingX: 'md',
      paddingY: 'xs',
      whiteSpace: 'no-wrap',
      cursor: 'pointer',
      textAlign: 'center',
      userSelect: 'none',
      $active: {
        color: val => val ? 'primary' : null
      }
    }
  }
}
